export default [
  {
      path: '/deployments',
      component: () => import('../pages/deployments/Index.vue'),
      children: [
        {
            path: '',
            name: 'deployments/list',
            meta: {
                layout: 'default',
                breadcrumb: [{ label: 'Deployments' }],
            },
            component: () => import('../pages/deployments/Deployments.vue'),
        },
        {
            path: 'add',
            name: 'deployments/add',
            meta: {
                layout: 'default',
                breadcrumb: [{ label: 'Deployments', to: { name: 'deployments' } }, { label: 'Add Deployment' }],
            },
            component: () => import('../pages/deployments/AddDeployment.vue'),
        },{
            path: ':id',
            name: 'deployments/detail',
            meta: {
                layout: 'default',
                breadcrumb: [{ label: 'Deployments', to: { name: 'deployments' } }],
            },
            component: () => import('../pages/deployments/DeploymentDetail.vue'),
        },
        
      ],
  },
];
